/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_IdInputs */



/**
* | output |
* | --- |
* | "Team Project Id" |
*
* @param {Team_Project_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_id = /** @type {((inputs?: Team_Project_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID du projet d’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teamprojekt-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID progetto di squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор командного проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación del proyecto de equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队项目 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do projeto da equipe")
	return /** @type {LocalizedString} */ ("Team Project Id")
});